// Dar ekranlarda (telefon) uygulamaya girerken bir kez uyarı gösterir.
// "Yine de devam et" denirse tercih oturum boyunca saklanır ve sayfa yeniden açılır;
// index.html'deki satır içi betik, sayfa açılırken genişliği 1280 px'e sabitler
// (açılışta verilmeyen viewport değişikliğini telefon tarayıcıları ölçeklemiyor).
const DAR_EKRAN = 900;
const ANAHTAR = "masaustu-devam";

function devamEdildi() {
	try {
		return sessionStorage.getItem(ANAHTAR) === "1";
	} catch {
		return false;
	}
}

export function masaustuUyarisiGoster() {
	// clientWidth viewport genişliğidir; taşan içerikten etkilenmez
	const genislik = document.documentElement.clientWidth;
	if (genislik >= DAR_EKRAN || devamEdildi()) return;
	if (document.getElementById("masaustu-uyari")) return;

	const el = document.createElement("div");
	el.id = "masaustu-uyari";
	el.style.width = `${genislik}px`;
	el.setAttribute("role", "alertdialog");
	el.setAttribute("aria-modal", "true");
	el.setAttribute("aria-labelledby", "masaustu-uyari-baslik");
	el.innerHTML = `
		<div class="masaustu-uyari-kutu">
			<h2 id="masaustu-uyari-baslik">Bu uygulama masaüstü için tasarlandı</h2>
			<p>Tablolar ve formlar geniş ekran gerektiriyor. En iyi deneyim için bilgisayardan açmanızı öneririz.</p>
			<button type="button">Yine de devam et</button>
		</div>
	`;
	el.querySelector("button").addEventListener("click", () => {
		try {
			sessionStorage.setItem(ANAHTAR, "1");
			// reload() önceki yakınlaştırmayı geri getirir; yeni gezinme getirmez
			location.replace(location.href);
		} catch {
			// depolama kapalıysa sadece uyarıyı kapat
			el.remove();
		}
	});
	document.body.appendChild(el);
	el.querySelector("button").focus();
}
